import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=ed6ec904&scoped=true"
import script from "./ProfileCard.vue?vue&type=script&lang=js"
export * from "./ProfileCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6ec904",
  null
  
)

export default component.exports